document.addEventListener("DOMContentLoaded", () => {
    // document.addEventListener('click', function(event) {
    //     const radioCheck = event.target.closest('.radioChecSingle');
    //     if (radioCheck) {
    //         const radioInput = radioCheck.querySelector('input[type="radio"]');
    //         if (radioInput) {
    //             const priceText = radioInput.getAttribute('data-price');
    //             const comparedPriceText = radioInput.getAttribute('data-compared-price');

    //             if (priceText && comparedPriceText) {
    //                 const priceNumber = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;
    //                 const comparedPriceNumber = parseFloat(comparedPriceText.replace(/[^0-9.]/g, '')) || 0;
    //                 const inputValue = parseFloat(radioInput.value) || 1; // Default to 1 if invalid value

    //                 const totalPrice = (priceNumber * inputValue).toFixed(2);
    //                 const totalComparedPrice = (comparedPriceNumber * inputValue).toFixed(2);

    //                 const stickyPriceElements = document.querySelectorAll('.sticky-price');
    //                 const stickyComparedPriceElements = document.querySelectorAll('.sticky-price-compared-price');
                    
    //                 stickyPriceElements.forEach(el => {
    //                     el.textContent = `$${totalPrice}`;
    //                 });
                    
    //                 stickyComparedPriceElements.forEach(el => {
    //                     el.textContent = `$${totalComparedPrice}`;
    //                 });
    //               // console.log("inputValue", inputValue)

    //                 const quantityInput = document.querySelector('.quantity__input');
    //                 if (quantityInput) {
    //                     quantityInput.value = inputValue;
    //                 } else {
    //                     console.error('Quantity input element not found');
    //                 }
    //             } else {
    //                 console.error('Price or compared price attributes not found on radio input');
    //             }
    //         } else {
    //             console.error('Radio input not found inside the div');
    //         }
    //     }
    // });

    $('.scrolltoReview').click(function() {
        $('html, body').animate({
            scrollTop: $('.product-page-review-banner').offset().top
        }, 0); // Adjust 1000 for the scroll speed in milliseconds
    });

});